import { Cents, Money } from '@betterment/core';
import { useGraphQLMutation } from '@betterment/graphql';
import { isUndefined } from 'es-toolkit/compat';

import { ValidateFinancialSecurityOrderRequestDocument } from '../../buy-order-flow/graphql/mutation.validateFinancialSecurityOrderRequest.generated';
import { FinancialSecurityOrderRequestDirection } from '../../graphql/schema';

type ValidationInput = {
  accountId: string;
  securityId: string;
  orderSharesAmount?: number;
  orderDollarAmountCents?: Cents;
  sellAll: boolean;
};

export const useOrderValidation = () => {
  const [validateFinancialSecurityOrderRequest, { loading }] = useGraphQLMutation(
    ValidateFinancialSecurityOrderRequestDocument
  );

  const validateOrder = async (input: ValidationInput) => {
    const { accountId, securityId, orderSharesAmount, orderDollarAmountCents, sellAll } = input;

    const hasSharesAmount = !isUndefined(orderSharesAmount);
    const hasDollarAmount = !isUndefined(orderDollarAmountCents);
    if (hasSharesAmount && hasDollarAmount) {
      throw new Error('Only one of orderSharesAmount or orderDollarAmountCents should be provided');
    }
    if (!hasSharesAmount && !hasDollarAmount) {
      throw new Error('Either orderSharesAmount or orderDollarAmountCents must be provided');
    }

    const value = hasSharesAmount ? { shares: orderSharesAmount } : { amount: Money(orderDollarAmountCents!) };

    const { data: validationResult } = await validateFinancialSecurityOrderRequest({
      variables: {
        input: {
          accountId: { directTradingAccountId: accountId },
          financialSecurityId: securityId,
          direction: FinancialSecurityOrderRequestDirection.Sell,
          value,
          sellAll,
        },
      },
    });

    return validationResult?.validateFinancialSecurityOrderRequest;
  };

  return { validateOrder, loading };
};
